export default "__VITE_ASSET__Cle2a708__"